import React, { useEffect, useState } from "react";
import { AdminSearchBrands, ViewAdminBrands, getCategories } from "../utils/Api/ApiCalls";
import { useRecoilValue } from "recoil";
import { userState } from "../Services/RecoilAtoms";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";

const Categories = () => {
  const currentUser = useRecoilValue(userState);
  const [brandData, setBrandData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [ size, setSize ] = useState();
  const [categories, setCategories] = useState([]);
  const [temp, setTemp] = useState([]);
  const [restart, setRestart] = useState(false);

  const itemsPerPage = 5; 

  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);

  // Simulate fetching items from another resources.
  // (This could be items from props; or items loaded in a local state
  // from an API endpoint with useEffect and useState)
  const endOffset = itemOffset + itemsPerPage;
  let currentItems = categories?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(categories?.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % categories?.length;
    setItemOffset(newOffset);
  };


  const ViewAllBrands = async () => {
    try {
      const response = await ViewAdminBrands(
        currentUser.data.info.id,
        currentUser.data.token
      );
      setBrandData(response.data);
      
    } catch (err) {
      return err;
    }
  };

  const searchBrands = async () => {
    try {
      // const response = await fetch(
      //   // `http://localhost:7045/api/v1/brands/search?name=${searchTerm}`
      //   `https://argoneworldadminbackend.findfood.ng/api/v1/brands/search?name=${searchTerm}`
      // );

      const response = await AdminSearchBrands(searchTerm, currentUser.data.token);
       const data = await response.json();
      setBrandData(data.data);
    } catch (err) {
      console.error("Error searching for brands:", err);
    }
  };

  useEffect(() => {
    GetAllCategories();
  }, [restart]);
  const GetAllCategories = async () => {
    try {
      const response = await getCategories();
      console.log(response.categories)
      setCategories(response.categories);
      setTemp(response.categories);
      
    } catch (err) {
      return err;
    }
  };
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const onSearch = async () => {
    try {
      const response = await getCategories(searchTerm, size);
      setCategories(response.categories);
      setTemp(response.categories);
      
    } catch (err) {
      return err;
    }
  }
  const onSelectionChange = async(e) => {
    const { name, value } = e.target;
   // setTemp({});
    if(value !== "all" && temp.length > parseInt(value)){
      // setSize(parseInt(value));
      // try {
      //   const response = await getCategories(searchTerm, parseInt(value));
      //   setCategories(response.categories);
      //   
      // } catch (err) {
      //   return err;
      // }
      setCategories(categories.slice((parseInt(value))))
    }else{
      setCategories(temp);
    }
    
  }
  return (
    // <section class="content-main">
    //   <div class="content-header">
    //     <div>
    //       <h2 class="content-title card-title">Categories</h2>
    //       <p>Add, edit or delete a category</p>
    //     </div>
    //     <div>
    //       <Link to="/category-form" class="btn btn-primary">
    //         <i class="text-muted material-icons md-post_add"></i>Add New Category
    //       </Link>
    //     </div>
    //   </div>
    //   <div class="card mb-4">
    //     <header class="card-header">
    //       <div class="row gx-3">
    //         <div class="col-lg-4 mb-lg-0 mb-15 me-auto">
    //           <div>All Brands</div>
    //           {/* <form onSubmit={handleSearchSubmit}>
    //             <input
    //               type="text"
    //               placeholder="Search..."
    //               className="form-control"
    //               value={searchTerm}
    //               onChange={handleSearchChange}
    //             />
    //           </form> */}
    //         </div>
    //         {/* <div class="col-lg-2 col-6">
    //           <div class="custom_select">
    //             <select class="form-select select-nice">
    //               <option selected>Categories</option>
    //               <option>Technology</option>
    //               <option>Fashion</option>
    //               <option>Home Decor</option>
    //               <option>Healthy</option>
    //               <option>Travel</option>
    //               <option>Auto-car</option>
    //             </select>
    //           </div>
    //         </div>
    //         <div class="col-lg-2 col-6">
    //           <input type="date" class="form-control" name="" />
    //         </div> */}
    //       </div>
    //     </header>

    //     <div class="card-body">
    //       <div class="row gx-3">
    //         {brandData?.length >= 1 ? (
    //           <>
    //             {brandData?.map((props) => (
    //               <div class="col-xl-2 col-lg-3 col-md-4 col-6" key={props.id}>
    //                 <figure class="card border-1">
    //                   <div class="card-header bg-white text-center">
    //                     <img
    //                       style={{
    //                         height: "70px",
    //                         width: "100%",
    //                         objectFit: "cover",
    //                       }}
    //                       // src={`http://localhost:7045/uploads/${props?.image[0]?.img}`}
    //                       src={`https://argoneworldadminbackend.findfood.ng/uploads/${props?.image[0]?.img}`}
    //                       class="img-fluid"
    //                       alt="Logo"
    //                     />
    //                   </div>
    //                   <figcaption class="card-body text-center">
    //                     <h6 class="card-title m-0">{props.name}</h6>
    //                     <a href="#"> {props?.product?.length} items </a>
    //                   </figcaption>
    //                 </figure>
    //               </div>
    //             ))}
    //           </>
    //         ) : (
    //           <div>No brand found</div>
    //         )}
    //       </div>
    //     </div>
    //   </div>
    // </section>
    <section class="content-main">
      <div class="content-header">
        <div>
          <h2 class="content-title card-title">Categories</h2>
          <p>Manage categories, subcategories, and brands.</p>
        </div>
        <div>
          <Link to="/category-form" class="btn btn-primary">
            <i class="text-muted material-icons md-post_add"></i>Add New Category
          </Link>
        </div>
      </div>
      <div class="card mb-4">
        <header class="card-header">
          <div class="row gx-3">
            <div class="col-lg-4 col-md-6 me-auto">
              <input
                type="text"
                placeholder="Search by category name, description"
                class="form-control"
                value={searchTerm} onChange={handleSearchChange} onKeyUp={onSearch}
              />
            </div>
            {/* <div class="col-lg-2 col-6 col-md-3">
            <select class="form-select">
              <option>Status</option>
              <option>Active</option>
              <option>Disabled</option>
              <option>Show all</option>
            </select>
          </div> */}
            <div class="col-lg-2 col-6 col-md-3">
              {/* <select class="form-select" name="selection" onChange={onSelectionChange}>
                <option value="all">All</option>
                <option value="1">Show 5</option>
                <option value="5">Show 5</option>
                <option value="10">Show 10</option>
                <option value="20">Show 20</option>
                <option value="30">Show 30</option>
                <option value="40">Show 40</option>
              </select> */}
            </div>
          </div>
        </header>

        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th scope="col">S/N</th>
                  <th scope="col">Category Name</th>
                  <th scope="col">Category Id</th>
                  <th scope="col">Created Date</th>
                  <th scope="col">Description</th>
                  <th scope="col" class="text-end">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {categories && categories.length > 0 ? categories.map((category, i) =>
                  <tr key={"category" + i}>
                    <td>{(i + 1)}</td>
                    <td>{category.categoryName}</td>
                    <td>{category.ID}</td>
                    <td>{new Date(category.createdDate).toLocaleDateString()}</td>
                    <td>{category.description || "N/A"}</td>
                    <td class="text-end">
                      {/* <div class="dropdown">
                        <a
                          href="#"
                          data-bs-toggle="dropdown"
                          class="btn btn-light rounded btn-sm font-sm"
                        >
                          <i class="material-icons md-more_horiz"></i>
                        </a>
                        <div class="dropdown-menu mb-5">
                          <Link
                            class="dropdown-item"
                            to={`/view-category/${category.ID}`}
                          >
                            View
                          </Link>
                          <Link
                            class="dropdown-item"
                            to={`/update-category/${category.ID}`}>
                            Update
                          </Link>
                          {/* <Link class="dropdown-item text-danger" to="#">
                            Delete
                          </Link> 
                        </div>
                      </div> */}
                      <Link
                            class="dropdown-item"
                            to={`/view-category/${category.ID}`}
                          >
                            View
                          </Link>
                          <Link
                            class="dropdown-item"
                            to={`/update-category/${category.ID}`}>
                            Update
                          </Link>
                    </td>
                  </tr>)
                  : (
                    <div>No order Found</div>
                  )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* <div class="pagination-area mt-30 mb-50">
      <nav aria-label="Page navigation example">
      <ReactPaginate
              nextLabel="Next"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              previousLabel="Previous"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link w-auto"
              nextClassName="page-item"
              nextLinkClassName="page-link w-auto"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination justify-content-start"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
      </nav>
    </div> */}
    </section>
  );
};

export default Categories;
